import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, computed } from 'vue'
import useGlobal from '@/composables/useGlobal'
import { useUserStore } from '@/stores/user'
import { useRoute } from 'vue-router'
import useLogout from '@/composables/useLogout'
import { logo_alternative } from '@/const'

import {
PROFILE_PAGE_NAME,
SELLERS_LIST_PAGE_NAME,
BUYERS_LIST_PAGE_NAME,
OUTLETS_LIST_PAGE_NAME,
REGISTRATIONS_LIST_PAGE_NAME,
MOTIVATIONS_LIST_PAGE_NAME,
REPORTS_LIST_PAGE_NAME,
PAYMENTS_LIST_PAGE_NAME,
GOODS_REMAINING_LIST_PAGE_NAME,
PUBLICATIONS_LIST_PAGE_NAME,
ANALYTICS_DETAILS_PAGE_NAME,
} from '@/components/pages/cabinet/routes'

import { userRole } from '@/const'

const adminRole = '1'
const accountantRole = '2'


export default /*@__PURE__*/_defineComponent({
  __name: 'Sidebar',
  props: {
  close: Function,
},
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props

const { $t } = useGlobal()
const store = useUserStore()
const route = useRoute()
const isClosed = ref(false)
const profile = computed(() => store.profile)
const logoutQuestion = $t('Are you sure you want to log out?')

const hasAccess = (requiredRoles) => requiredRoles.includes(userRole)

const menuItems = ref([
  { title: $t('Profile data'), icon: 'i-user', routeName: PROFILE_PAGE_NAME, roles: [adminRole, accountantRole] },
  { title: $t('Buyers'), icon: 'i-buyers', routeName: BUYERS_LIST_PAGE_NAME, roles: [adminRole] },
  { title: $t('Sellers'), icon: 'i-delivery', routeName: SELLERS_LIST_PAGE_NAME, roles: [adminRole] },
  { title: $t('Registration of sellers'), icon: 'i-clipboard', routeName: REGISTRATIONS_LIST_PAGE_NAME, roles: [adminRole] },
  { title: $t('Outlets'), icon: 'i-map-pin', routeName: OUTLETS_LIST_PAGE_NAME, roles: [adminRole] },
  { title: $t('Sales reports'), icon: 'i-clipboard-list', routeName: REPORTS_LIST_PAGE_NAME, roles: [adminRole] },
  { title: $t('Payments'), icon: 'i-credit-card', routeName: PAYMENTS_LIST_PAGE_NAME, roles: [adminRole, accountantRole] },
  { title: $t('Motivations'), icon: 'i-percent', routeName: MOTIVATIONS_LIST_PAGE_NAME, roles: [adminRole] },
  { title: $t('Remaining goods'), icon: 'i-package', routeName: GOODS_REMAINING_LIST_PAGE_NAME, roles: [adminRole] },
  { title: $t('Analytics'), icon: 'i-analytics', routeName: ANALYTICS_DETAILS_PAGE_NAME, roles: [adminRole] },
  { title: $t('Publications'), icon: 'i-newspaper', routeName: PUBLICATIONS_LIST_PAGE_NAME, roles: [adminRole] },
])

function toggleSidebar() {
  isClosed.value = !isClosed.value
}

const __returned__ = { props, $t, store, route, isClosed, profile, logoutQuestion, adminRole, accountantRole, hasAccess, menuItems, toggleSidebar, ref, watch, computed, get useGlobal() { return useGlobal }, get useUserStore() { return useUserStore }, get useRoute() { return useRoute }, get useLogout() { return useLogout }, get logo_alternative() { return logo_alternative }, get PROFILE_PAGE_NAME() { return PROFILE_PAGE_NAME }, get SELLERS_LIST_PAGE_NAME() { return SELLERS_LIST_PAGE_NAME }, get BUYERS_LIST_PAGE_NAME() { return BUYERS_LIST_PAGE_NAME }, get OUTLETS_LIST_PAGE_NAME() { return OUTLETS_LIST_PAGE_NAME }, get REGISTRATIONS_LIST_PAGE_NAME() { return REGISTRATIONS_LIST_PAGE_NAME }, get MOTIVATIONS_LIST_PAGE_NAME() { return MOTIVATIONS_LIST_PAGE_NAME }, get REPORTS_LIST_PAGE_NAME() { return REPORTS_LIST_PAGE_NAME }, get PAYMENTS_LIST_PAGE_NAME() { return PAYMENTS_LIST_PAGE_NAME }, get GOODS_REMAINING_LIST_PAGE_NAME() { return GOODS_REMAINING_LIST_PAGE_NAME }, get PUBLICATIONS_LIST_PAGE_NAME() { return PUBLICATIONS_LIST_PAGE_NAME }, get ANALYTICS_DETAILS_PAGE_NAME() { return ANALYTICS_DETAILS_PAGE_NAME }, get userRole() { return userRole } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})